// app/frontend/components/ui/Cards/L2KCard.tsx
import { Paper, PaperProps, MantineSpacing } from "@mantine/core";
import { ReactNode } from "react";

interface L2KCardProps extends Omit<PaperProps, "children"> {
  children: ReactNode;
  variant?: "default" | "elevated" | "outlined";
  glow?: boolean;
  p?: MantineSpacing;
}

/**
 * L2KCard - Branded card component with glass-morphism effect
 * Variants: default, elevated, outlined
 */
export function L2KCard({
  children,
  variant = "default",
  glow = false,
  p = "xl",
  style,
  ...props
}: L2KCardProps) {
  const variants = {
    default: {
      backgroundColor: "rgba(255, 255, 255, 0.03)",
      border: "1px solid rgba(255, 255, 255, 0.1)",
      backdropFilter: "blur(10px)",
    },
    elevated: {
      backgroundColor: "rgba(255, 255, 255, 0.05)",
      border: "1px solid rgba(255, 255, 255, 0.1)",
      backdropFilter: "blur(15px)",
      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
    },
    outlined: {
      backgroundColor: "transparent",
      border: "1px solid rgba(255, 152, 0, 0.3)",
      backdropFilter: "blur(5px)",
    },
  };

  const glowStyle = glow
    ? {
        boxShadow: "0 0 30px rgba(255, 152, 0, 0.15)",
      }
    : {};

  return (
    <Paper
      radius="md"
      p={p}
      style={{
        ...variants[variant],
        ...glowStyle,
        ...style,
      }}
      {...props}
    >
      {children}
    </Paper>
  );
}

export default L2KCard;
